import { Collapse, CollapseProps } from 'antd';
import clx from 'classnames';
import * as React from 'react';

import styled from 'styled-components';

const StyledCollapse = styled(Collapse)`
  &.ant-collapse {
    /* margin-top: -12px; */
    padding-bottom: 12px;
    > .ant-collapse-item {
      > .ant-collapse-header {
        padding-left: 0;
        padding-right: 0;
        font-weight: 600;
      }
      /* &:first-child > .ant-collapse-header {
        padding-top: 0;
      } */
      > .ant-collapse-content > .ant-collapse-content-box {
        padding-left: 0;
        padding-right: 0;
        padding-top: 0;
        padding-bottom: 0;
      }
    }
    &.padding-vertical,
    &.padding-all {
      > .ant-collapse-item {
        > .ant-collapse-content > .ant-collapse-content-box {
          padding-top: 12px;
          padding-bottom: 12px;
        }
      }
      &.padding-horizontal,
      &.padding-all {
        > .ant-collapse-item {
          > .ant-collapse-content > .ant-collapse-content-box {
            padding-left: 12px;
            padding-right: 12px;
          }
        }
      }
    }
    &.remove-top-padding {
      > .ant-collapse-item:first-child {
        > .ant-collapse-header {
          padding-top: 0;
        }
      }
    }
    &.remove-bottom-padding {
      padding-bottom: 0;
      > .ant-collapse-item:last-child {
        > .ant-collapse-header {
          padding-bottom: 0;
        }
      }
    }
  }
`;

export interface INakedCollapseProps extends CollapseProps {
  contentPadding?: 'vertical' | 'horizontal' | 'all' | 'none';
  removeTopPadding?: boolean;
  removeBottomPadding?: boolean;
}

export function NakedCollapse(props: INakedCollapseProps) {
  const {
    contentPadding = 'none',
    removeTopPadding = true,
    removeBottomPadding,
    className,
    ...otherProps
  } = props;
  return (
    <StyledCollapse
      ghost
      {...otherProps}
      className={clx(className, `padding-${contentPadding}`, {
        'remove-top-padding': removeTopPadding,
        'remove-bottom-padding': removeBottomPadding,
      })}
    />
  );
}
